import { render, staticRenderFns } from "./GroupOrder.vue?vue&type=template&id=5ee8a5ed&scoped=true&"
import script from "./GroupOrder.vue?vue&type=script&lang=js&"
export * from "./GroupOrder.vue?vue&type=script&lang=js&"
import style0 from "./GroupOrder.vue?vue&type=style&index=0&id=5ee8a5ed&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee8a5ed",
  null
  
)

export default component.exports